import { z } from "zod";
import {
  AdapterIdSchema,
  ChapterIndexSchema,
  IsoDateSchema,
  UrlSchema,
  unsafeBrandIsoDate,
} from "../data-model/primitives.js";
import type { Url } from "../data-model/primitives.js";
import { NovelMetadataSchema, ChapterRefSchema } from "../data-model/schema.js";

export const ResumeFailureRecordSchema = z
  .object({
    index: ChapterIndexSchema,
    lastError: z.object({ code: z.string(), message: z.string() }).readonly(),
  })
  .readonly();

export type ResumeFailureRecord = z.infer<typeof ResumeFailureRecordSchema>;

export const ResumeStateSchema = z
  .object({
    schemaVersion: z.literal(1),
    url: UrlSchema,
    adapterId: AdapterIdSchema,
    metadata: NovelMetadataSchema.nullable(),
    toc: z.array(ChapterRefSchema).readonly().nullable(),
    completed: z.array(ChapterIndexSchema).readonly(),
    failed: z.array(ResumeFailureRecordSchema).readonly(),
    startedAt: IsoDateSchema,
    updatedAt: IsoDateSchema,
  })
  .readonly();

export type ResumeState = z.infer<typeof ResumeStateSchema>;

export function nowIso(): ResumeState["startedAt"] {
  return unsafeBrandIsoDate(new Date().toISOString());
}

export function freshState(url: Url, adapterId: ResumeState["adapterId"]): ResumeState {
  const now = nowIso();
  return {
    schemaVersion: 1,
    url,
    adapterId,
    metadata: null,
    toc: null,
    completed: [],
    failed: [],
    startedAt: now,
    updatedAt: now,
  };
}
